// Intro.js
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { gsap } from 'gsap';
import '../estilos/Intro.css';
import empaticalogo from "../recursos/empatica.png";
import Three from "../componentes/camino/Three.jsx";
import Luces from './camino/Luces';
import privado from '../recursos/Privado-Colores-Web.webp';
import publico from '../recursos/Publico-Colores-Web.webp';
import consultoria from '../recursos/Consultoria-Colores-Web.webp';
import fondoDefault from '../recursos/Cerebro-Colores-Web.webp';
import { useHistory } from 'react-router-dom';
import fondoMovil from '../recursos/Img-Cerebro-2.png';
import IntroVideo from './IntroVideo.js';
import privadoMovil from '../recursos/Img-Privada.png';
import publicoMovil from '../recursos/Img-Publica.png';
import consultoriaMovil from '../recursos/Img-Consultoria.png';

const Intro3 = ({ onComplete }) => {
    const [animationTyping, setIsAnimationTyping] = useState(false);
    const [backgroundImage, setBackgroundImage] = useState(fondoDefault);
    const [fixedBackground, setFixedBackground] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [showSubMenu, setShowSubMenu] = useState(null);
    const history = useHistory();
    const [showVideo, setShowVideo] = useState(true);


    useEffect(() => {
        gsap.fromTo(".curtain",
            { y: '-100%' },
            { y: '0%', duration: 0, ease: 'power2.inOut' }
        );

        setTimeout(() => {
            setIsAnimationTyping(true)
        }, 1000)
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);

            if (mobile) {
                if (fixedBackground) {
                    switch (fixedBackground) {
                        case privado:
                            setBackgroundImage(privadoMovil);
                            break;
                        case publico:
                            setBackgroundImage(publicoMovil);
                            break;
                        case consultoria:
                            setBackgroundImage(consultoriaMovil);
                            break;
                        default:
                            setBackgroundImage(fondoMovil);
                    }
                } else {
                    setBackgroundImage(fondoMovil);
                }
            } else {
                setBackgroundImage(fixedBackground || fondoDefault);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [fixedBackground]);



    const handleButtonHover = (sector) => {
        setHoveredButton(sector);
        switch (sector) {
            case "PRIVADO":
                setBackgroundImage(isMobile ? privadoMovil : privado);
                break;
            case "PUBLICO":
                setBackgroundImage(isMobile ? publicoMovil : publico);
                break;
            case "CONSULTORIA":
                setBackgroundImage(isMobile ? consultoriaMovil : consultoria);
                break;
            default:
                setBackgroundImage(isMobile ? fondoMovil : fondoDefault);
        }
    };

    useEffect(() => {
        const hasSeenVideo = sessionStorage.getItem('hasSeenVideo');

        if (!hasSeenVideo) {
            setShowVideo(true);
            sessionStorage.setItem('hasSeenVideo', 'true');
        } else {
            setShowVideo(false);
        }
    }, []);


    const handleButtonLeave = () => {
        setHoveredButton(null);
        setBackgroundImage(isMobile ? fondoMovil : fondoDefault);
    };

    const handleButtonClick = (sector) => {
        let selectedImage;
        switch (sector) {
            case "PRIVADO":
                selectedImage = isMobile ? privadoMovil : privado;
                history.push("/empaticapage/privado");
                break;
            case "PUBLICO":
                selectedImage = isMobile ? publicoMovil : publico;
                history.push("/empaticapage/publico");
                break;
            case "CONSULTORIA":
                selectedImage = isMobile ? consultoriaMovil : consultoria;
                history.push("/empaticapage/consultoria");
                break;
            default:
                selectedImage = isMobile ? fondoMovil : fondoDefault;
                history.push("/empaticapage");
        }

        setFixedBackground(selectedImage);
        onComplete(sector);

        gsap.to(".curtain", {
            y: '-100%',
            duration: 2,
            ease: 'power2.inOut',
        });
    };

    const toggleSubMenu = (menu) => {
        setShowSubMenu(showSubMenu === menu ? null : menu);
    };

    const getGradientBackground = (image) => {
        return `
          linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 40%,  
            rgba(6, 22, 43, 1) 60%,
            rgba(29, 78, 140, 1) 90%
          ),
          url(${image})
        `;
    };

    const [hoveredButton, setHoveredButton] = useState(null);
    if (showVideo) {
        return (
            <IntroVideo
                onVideoEnd={() => {

                    setShowVideo(false);
                }}
            />
        );
    }
    return (
        <div
            id="inicio"
            className="curtain"
            style={{
                overflow: 'hidden',
                backgroundImage: getGradientBackground(backgroundImage),
                backgroundSize: isMobile ? 'cover' : '100% auto',
                backgroundPosition: isMobile ? 'center 95%' : 'center 0.5%',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#06162b',
                transition: 'background-image 0.3s ease, background-size 0.3s ease',
            }}>
            <div className="overlay2">
                {isMobile ? (
                    <div className="flex flex-row justify-center items-center gap-3 p-4">
                        {/* Botón Empatica Consulting */}
                        <button
                            onClick={() => handleButtonClick("CONSULTORIA")}
                            style={{
                                minWidth: '160px',
                                height: '60px',
                                padding: '4px 12px',
                                borderRadius: '999px',
                                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                color: '#1b4a85',
                                backdropFilter: 'blur(6px)',
                                border: '1px solid #1b4a85',
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '1.3',
                                margin: '-3px 0'
                            }}>
                                <span style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    marginBottom: '-5px'
                                }}>Empatica</span>
                                <span style={{ fontSize: '14px' }}>Consulting</span>
                            </div>
                        </button>

                        {/* Botón Empatica Soluciones con submenú COMPLETO */}
                        <div className="relative">
                            <button
                                onClick={() => toggleSubMenu('soluciones')}
                                style={{
                                    minWidth: '160px',
                                    height: '60px',
                                    padding: '4px 12px',
                                    borderRadius: '999px',
                                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                    color: '#1b4a85',
                                    backdropFilter: 'blur(6px)',
                                    border: '1px solid #1b4a85',
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    lineHeight: '1.3',
                                    margin: '-3px 0'
                                }}>
                                    <span style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        marginBottom: '-5px'
                                    }}>Empatica</span>
                                    <span style={{ fontSize: '14px' }}>Soluciones</span>
                                </div>
                            </button>

                            {/* Submenú completo */}
                            {showSubMenu === 'soluciones' && (
                                <div className="absolute z-10 w-full mt-2 space-y-1" style={{ left: 0 }}>
                                    <button
                                        onClick={() => handleButtonClick("PUBLICO")}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            padding: '4px 12px',
                                            borderRadius: '999px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                            color: '#1b4a85',
                                            backdropFilter: 'blur(6px)',
                                            border: '1px solid #1b4a85',
                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            lineHeight: '1.3',
                                            margin: '-3px 0'
                                        }}>
                                            <span style={{ fontSize: '14px' }}>Iniciativa</span>
                                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Pública</span>
                                        </div>
                                    </button>
                                    <button
                                        onClick={() => handleButtonClick("PRIVADO")}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            padding: '4px 12px',
                                            borderRadius: '999px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                            color: '#1b4a85',
                                            backdropFilter: 'blur(6px)',
                                            border: '1px solid #1b4a85',
                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            lineHeight: '1.3',
                                            margin: '-3px 0'
                                        }}>
                                            <span style={{ fontSize: '14px' }}>Sector</span>
                                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Privado</span>
                                        </div>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-row justify-start items-center gap-4 p-4 overflow-x-auto whitespace-nowrap">
                        {[
                            { id: "CONSULTORIA", title: "Consultoría", subtitle: "Empresarial" },  
                            { id: "PRIVADO", title: "Iniciativa Privada", subtitle: "Negocios" },
                            { id: "PUBLICO", title: "Sector Público", subtitle: "Gobierno" },
                        ].map(({ id, title, subtitle }) => (
                            <button
                                key={id}
                                onMouseEnter={() => handleButtonHover(id)}
                                onMouseLeave={handleButtonLeave}
                                onClick={() => handleButtonClick(id)}
                                className="hasStarted backdrop-blur-md bg-white/10 border border-white/30 text-white rounded-full transition-all duration-300 hover:bg-white/20 flex items-center justify-center"
                                style={{
                                    minWidth: "220px",
                                    height: "72px",
                                    padding: "8px 20px",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                                    color: "white",
                                    backdropFilter: "blur(6px)",
                                    border: "1px solid rgba(255, 255, 255, 0.5)",
                                    transition: "transform 0.3s ease, background-color 0.3s ease",
                                    transform: hoveredButton === id ? "scale(1.05)" : "scale(1)",
                                    flexShrink: 0,
                                }}
                            >
                                <div className="flex flex-col items-center leading-tight text-center">
                                    <span>{title}</span>
                                    <span className="text-sm font-normal opacity-80 -mt-0.5">{subtitle}</span>
                                </div>
                            </button>
                        ))}
                    </div>

                )}
            </div>

            <div className="relative w-full h-screen">
                <Luces />

                {animationTyping && (
                    <div className="absolute inset-0 flex items-center justify-center px-4 text-center">
                        <div className="max-w-[90%] md:max-w-[900px] text-base md:text-xl text-white pt-36 md:pt-0 md:leading-normal">
                            {"Soluciones asequibles que hacen más fácil tu día, más fuerte tu operación y más humano tu equipo."
                                .split(" ")
                                .map((word, index) => (
                                    <span
                                        key={index}
                                        className="animated-word"
                                        style={{ animationDelay: `${index * 0.06}s`, color: "white" }}
                                    >
                                        {word}&nbsp;
                                    </span>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Intro3;


const Intro2 = ({ onComplete }) => {
    const [animationTyping, setIsAnimationTyping] = useState(false);

    useEffect(() => {
        // Animación para mostrar la cortina
        gsap.fromTo(".curtain",
            { y: '-100%' },
            { y: '0%', duration: 0, ease: 'power2.inOut' } //duration: 1 es el original
        );

        setTimeout(() => {
            setIsAnimationTyping(true)
        }, 1000)

    }, []);


    const speedAnimationRef = useRef(0.55); // Ref para la velocidad de animación
    const scrollTimeoutRef = useRef(null); // Ref para el timeout de scroll
    const targetSpeedRef = useRef(0.55); // Ref para la velocidad objetivo
    const animationFrameRef = useRef(null);

    const handleWheel = useCallback((event) => {
        const delta = Math.abs(event.deltaY);
        //    console.log("wheel", delta);

        // Actualiza la velocidad de animación
        speedAnimationRef.current += delta * 0.0012;

        // Limpia el timeout anterior
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        // Configura el timeout para restablecer la velocidad después de 500ms sin movimiento
        scrollTimeoutRef.current = setTimeout(() => {
            console.log("aqui 1");
            //speedAnimationRef.current = 0.55; // Restablece la velocidad a la base

            // Inicia la transición suave hacia la velocidad objetivo
            const transitionSmoothly = () => {
                const currentSpeed = speedAnimationRef.current;
                const targetSpeed = targetSpeedRef.current;
                const speedDelta = targetSpeed - currentSpeed;

                // Suaviza la transición
                if (Math.abs(speedDelta) > 0.001) {
                    speedAnimationRef.current += speedDelta * 0.1; // Ajusta la tasa de interpolación
                    animationFrameRef.current = requestAnimationFrame(transitionSmoothly);
                } else {
                    speedAnimationRef.current = targetSpeed; // Ajusta la velocidad final
                }
            };

            transitionSmoothly();

        }, 500);
    }, []);

    useEffect(() => {
        // Agrega el listener de wheel al montar el componente
        window.addEventListener("wheel", handleWheel);

        // Limpia el listener al desmontar el componente
        return () => {
            window.removeEventListener("wheel", handleWheel);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, [handleWheel]);


    const handleButtonClick = (sector) => {
        console.log("han click", sector)
        onComplete(sector);

        // Animación para ocultar la cortina
        gsap.to(".curtain", {
            y: '-100%',
            duration: 2,
            ease: 'power2.inOut',
            //onComplete: onComplete
        });
    }

    return (
        <div className="curtai">


            <div className="overlay">

                {animationTyping ?
                    <h2 className="typing-demo">Hola, Somos <span className="span_gradient">Empatica Soluciones</span></h2>
                    : null}

                <p style={{ marginTop: 10 }}>Facilitando millones de vidas con soluciones asequibles.</p>
                <p style={{ marginTop: 10 }}>Conoce nuestros productos:</p>

                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>

                    <button
                        id="footer-hero-button"
                        className="hasStarted"
                        style={{
                            visibility: 'visible',
                            opacity: 1,
                            width: '179px',
                            pointerEvents: 'auto',
                            //transform: 'translate3d(-50%, 1em, 0px) rotateX(0deg)'
                        }}
                        onClick={() => handleButtonClick("PRIVADO")}
                    >
                        <div id="footer-hero-button-wrapper">
                            Sector Privado
                        </div>
                    </button>

                    <button
                        id="footer-hero-button"
                        className="hasStarted"
                        style={{
                            visibility: 'visible',
                            opacity: 1,
                            width: '179px',
                            pointerEvents: 'auto',
                            //transform: 'translate3d(-50%, 1em, 0px) rotateX(0deg)'
                        }}
                        onClick={() => handleButtonClick("PUBLICO")} >
                        <div id="footer-hero-button-wrapper">
                            Sector Público
                        </div>
                    </button>


                    <button
                        id="footer-hero-button"
                        className="hasStarted"
                        style={{
                            visibility: 'visible',
                            opacity: 1,
                            width: '179px',
                            pointerEvents: 'auto',
                            //  transform: 'translate3d(-50%, 1em, 0px) rotateX(0deg)'
                        }}
                        onClick={() => handleButtonClick("CONSULTORIA")}
                    >
                        <div id="footer-hero-button-wrapper">
                            Consultoria
                        </div>
                    </button>


                </div>

            </div>


            {/*animationTyping ?
                <h2 className="typing-demo">Hola, Somos <span className="span_gradient">Empatica Soluciones</span></h2>
                : null*/}

            <Three speedAnimationRef={speedAnimationRef} />

        </div>
    );
};

const Intro = ({ onComplete }) => {
    const [animationTyping, setIsAnimationTyping] = useState(false);

    useEffect(() => {
        // Animación para mostrar la cortina
        gsap.fromTo(".curtain",
            { y: '-100%' },
            { y: '0%', duration: 1, ease: 'power2.inOut' }
        );

        setTimeout(() => {
            setIsAnimationTyping(true)
        }, 1000)
    }, []);

    /*
    useEffect(() => {
        const typeSound = new Howl({
            src: require('../recursos/typing.mp3'),
            volume: 1.0,
            onload: () => console.log('Sound loaded successfully'),
            onloaderror: (id, error) => console.error('Error loading sound:', error)
        });

        if (animationTyping) {
            console.log('Playing sound'); // Añade un console.log para verificar
            typeSound.play();
        }
    }, [animationTyping]);*/

    const handleButtonClick = (sector) => {
        onComplete(sector);

        // Animación para ocultar la cortina
        gsap.to(".curtain", {
            y: '-100%',
            duration: 2,
            ease: 'power2.inOut',
            //onComplete: onComplete
        });
    }

    return (
        <div className="curtain">

            {/*<div className="content">
                {animationTyping ?
                    <div className="wrapper">
                        <div className="typing-demo">
                            Hola, Somos <span style={{ color: '#0f4c75', fontWeight: 700 }}>Empatica Soluciones</span>
                        </div>
                    </div>
                    : null
                }
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                        <a className="buttonSector" onClick={handleButtonClick}>Sector Privado</a>
                        <a className="buttonSector" onClick={handleButtonClick}>Sector Público</a>
                        <a className="buttonSector" onClick={handleButtonClick}>Consultoria</a>
                    </div>
                </div>
            </div>*/}


            {/*<div
                className="grandienteIntro"
                style={{
                    transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                    transformStyle: 'preserve-3d',
                    opacity: 1
                }}>
            </div>*/}


            <section className="home_cta"><div className="container-large">
                <div data-w-id="5e90a721-54cf-6f17-1c78-7353063fc75b"
                    className="home_cta_card"
                    style={{
                        transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                        transformStyle: 'preserve-3d',
                        opacity: 1
                    }}>

                    {animationTyping ?
                        <h2 className="typing-demo">Hola, Somos <span className="span_gradient">Empatica Soluciones</span></h2>
                        : null}

                    <p>Facilitando millones de vidas con soluciones asequibles.</p>
                    <p>Conoce nuestros productos:</p>
                    {/* <a href="/contact-us" className="button is-secondary w-button">Talk to us</a>*/}
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                            <a className="buttonSector" onClick={() => handleButtonClick("PRIVADO")}>Sector Privado</a>
                            <a className="buttonSector" onClick={() => handleButtonClick("PUBLICO")}>Sector Público</a>
                            <a className="buttonSector" onClick={() => handleButtonClick("CONSULTORIA")}>Consultoria</a>
                        </div>
                    </div>


                    <img src="https://cdn.prod.website-files.com/6501f1891917bde75ab542ee/650233d59b9a7a16b10beb85_Group%2069.svg" loading="lazy" alt="" className="graphic_brand-logo is-footer" />
                </div>
            </div>
                <img src={empaticalogo} alt="Floating Image" className="floating-image" />
            </section>



            {/* <div className="home_hero_gradient" >
            </div>*/}


        </div>
    );
};

//export default Intro;